import { Search, GitCompare, FileCheck, Wallet } from "lucide-react";

const steps = [
  { icon: Search, title: "Tell us what you need", desc: "Loan amount, tenure, and your credit range. Takes 20 seconds." },
  { icon: GitCompare, title: "Compare live offers", desc: "See real-time rates and fees from every major Indian lender." },
  { icon: FileCheck, title: "Apply in one click", desc: "Digital KYC. Minimal docs. We handle the paperwork." },
  { icon: Wallet, title: "Money in your account", desc: "Approved loans disburse within 24 hours to your bank." },
];

export const HowItWorks = () => (
  <section className="py-20 sm:py-24 bg-slate-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 mb-3">How it works</div>
        <h2 className="font-display text-3xl sm:text-4xl tracking-tight font-medium text-slate-900">
          From "I need money" to "money received" — in four steps.
        </h2>
      </div>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {steps.map(({ icon: Icon, title, desc }, i) => (
          <div key={i} className="bg-white border border-slate-200 rounded-2xl p-6 relative card-hover">
            <div className="text-[10px] font-bold text-emerald-600 uppercase tracking-[0.2em]">Step {i + 1}</div>
            <Icon className="w-6 h-6 text-slate-900 mt-4" />
            <div className="mt-4 font-display font-semibold text-lg text-slate-900">{title}</div>
            <div className="mt-1.5 text-sm text-slate-600 leading-relaxed">{desc}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
